export function weaslOpen(content, name, style, padding, width) {
	//Declare Built event
	var weaslBuilt = document.createEvent("Event");
	weaslBuilt.initEvent("weaslBuilt", true, true);

	// Create the modal structure
	var modal = {
		overlay: document.createElement("div"),
		container: document.createElement("div"),
		content: document.createElement("div"),
		close: document.createElement("button")
	};

	//Add classes and attributes

	modal.overlay.classList.add("weasl");
	modal.overlay.classList.add("weasl--name-" + name);
	modal.overlay.setAttribute("data-name", name);
	modal.overlay.addEventListener(
		"click",
		function(event) {
			if (event.target !== this) return;
			var name = document.body.querySelector(".weasl").dataset.name;
			event.preventDefault();
			weaslClose(event, name);
		},
		false
	);

	if (style) {
		modal.overlay.classList.add(style);
	}

	modal.container.classList.add("weasl__container");
	modal.container.setAttribute("role", "dialog");
	modal.container.setAttribute("tabindex", "0");

	if (padding) {
		modal.container.style.padding = padding;
	}
	if (width) {
		modal.container.style.maxWidth = width;
	}

	modal.content.classList.add("weasl__content");

	modal.content.innerHTML = content;

	modal.close.classList.add("weasl__close");
	modal.close.setAttribute("type", "button");
	modal.close.setAttribute("title", "Close modal");
	modal.close.setAttribute("tabindex", "0");
	modal.close.addEventListener(
		"click",
		function(event) {
			if (event.target !== this) return;
			var name = document.body.querySelector(".weasl").dataset.name;
			event.preventDefault();
			weaslClose(event, name);
		},
		false
	);

	// Add modal structure to dom
	modal.overlay.appendChild(modal.container);
	modal.container.appendChild(modal.content);
	modal.container.appendChild(modal.close);
	document.body.appendChild(modal.overlay);

	// Dispatch the built event.
	document.dispatchEvent(weaslBuilt);
}

//Declare opened event
var weaslOpened = document.createEvent("Event");
weaslOpened.initEvent("weaslOpened", true, true);
// Activate Modal
document.addEventListener(
	"weaslBuilt",
	function(e) {
		setTimeout(function() {
			document.body.classList.add("weasl--active");
		}, 0);
		setTimeout(function() {
			//Set focus
			document.body.querySelector(".weasl__container").focus();
			// Dispatch the open event.
			document.dispatchEvent(weaslOpened);
		}, 250);
	},
	false
);

// Close modal

export function weaslClose(event, name) {
	var weaslClosed = document.createEvent("Event");
	weaslClosed.initEvent("weaslClosed", true, true);

	var weaslClosedName = document.createEvent("Event");
	weaslClosedName.initEvent("weaslClosedName", true, true);

	// Remove active states from body.
	document.body.classList.remove("weasl--active");

	// Remove Content.

	setTimeout(function() {
		var weaslElem = document.body.querySelector(".weasl");
		weaslElem.parentNode.removeChild(weaslElem);
	}, 250);

	// Dispatch the close event.
	document.dispatchEvent(weaslClosed);
	document.dispatchEvent(weaslClosedName);
}

document.addEventListener(
	"click",
	function(event) {
		if (!event.target.matches(".weasl__close-button")) return;
		var name = document.body.querySelector(".weasl").dataset.name;
		event.preventDefault();
		weaslClose(event, name);
	},
	false
);

// Main weasl function
export function weasl(options) {
	// Declare the intiate event.
	var weaslInit = document.createEvent("Event");
	weaslInit.initEvent("weaslInit", true, true);

	// Dispatch the initiate event.
	document.dispatchEvent(weaslInit);

	var name = options.name,
		content = options.content,
		style = options.style,
		padding = options.padding,
		width = options.width;

	weaslOpen(content, name, style, padding, width);
}



//////////////////
// WEBPACK FOOTER
// /Users/steve/Code/select-technology-2020/web/app/themes/select-technology-2020/node_modules/@trepanation-pray/weasl/src/weasl.js
// module id = 23
// module chunks = 0